import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PropsWithChildren } from "react";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false
        }
    }
});

export default function QueryProvider({ children }: PropsWithChildren) {
    return <QueryClientProvider client={queryClient}>
        {children}
    </QueryClientProvider>
}